import React from "react";
import { MtaaWordmark } from "@/components/MtaaLogo";

export default function LaunchingSoon() {
  return (
    <div className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-[#0b0b0c] px-6 text-center text-neutral-100" data-testid="launching-soon">
      {/* subtle accent glows (restrained Kenyan red/green) */}
      <div aria-hidden className="pointer-events-none absolute -left-24 top-1/4 h-64 w-64 rounded-full bg-brand-green/10 blur-3xl" />
      <div aria-hidden className="pointer-events-none absolute -right-24 bottom-1/4 h-64 w-64 rounded-full bg-brand-red/10 blur-3xl" />

      <div className="relative z-10 flex w-full max-w-xl flex-col items-center">
        <div className="scale-125"><MtaaWordmark /></div>

        <p className="mt-8 font-display text-xs font-bold uppercase tracking-[0.3em] text-neutral-400" data-testid="ls-tagline">
          Buy. Sell. Belong.
        </p>

        <h1 className="mt-7 font-display text-3xl font-extrabold leading-[1.15] tracking-tight sm:text-4xl">
          Something for our community<br className="hidden sm:block" /> is coming.
        </h1>

        <p className="mt-5 max-w-md text-base leading-relaxed text-neutral-400">
          Mtaa is bringing Kenyans across Australia closer together — to buy, sell, discover, connect and belong.
        </p>

        <div className="mt-9 inline-flex items-center gap-2 rounded-full border border-neutral-800 bg-neutral-900/60 px-5 py-2">
          <span className="h-1.5 w-1.5 rounded-full bg-brand-green" />
          <span className="font-display text-sm font-bold uppercase tracking-[0.2em] text-neutral-200">Launching Soon</span>
        </div>
      </div>

      <footer className="absolute bottom-6 left-0 right-0 z-10 px-6 text-center text-xs text-neutral-500" data-testid="ls-footer">
        Made for the Kenyan community in Australia 🇰🇪 🇦🇺
      </footer>
    </div>
  );
}
